<template>
  <v-dialog
    :value="value"
    content-class="samplesDialog"
    @click:outside="closeDialog"
  >
    <div class="samplesDialog__header">
      <div class="samplesDialog__title">
        {{ $t('components.sampleSwatchesDialog.title') }}
      </div>
      <v-icon
        color="black"
        class="samplesDialog__close"
        large
        @click="closeDialog"
      >
        mdi-close
      </v-icon>
    </div>
    <div class="samplesDialog__inner">
      <template v-if="samples.length">
        <div
          class="samplesList"
        >
          <div
            v-for="(sample, index) in samples"
            :key="index"
            class="samplesList__item"
          >
            <v-img
              :src="sample.rendered_image"
              aspect-ratio="1"
              max-width="56px"
              class="samplesList__img"
              max-height="56px"
            />
            <div class="samplesList__text">
              <div class="samplesList__name">
                {{ sample.name }}
              </div>
              <div class="samplesList__desc">
                {{ $t('components.sampleSwatchesDialog.itemDesc') }}
              </div>
            </div>
            <div
              class="samplesList__delete"
              @click="deleteSample(index)"
            >
              <v-icon class="">
                mdi mdi-trash-can-outline
              </v-icon>
              <div class="samplesList__deleteText">
                {{ $t('components.sampleSwatchesDialog.remove') }}
              </div>
            </div>
          </div>
        </div>
        <div class="samplesPrice">
          <div class="samplesPrice__value">
            $ 0.00
          </div>
          <div class="samplesPrice__text">
            {{ $t('components.sampleSwatchesDialog.priceText') }}
          </div>
        </div>
      </template>
      <div class="samplesDialog__info">
        {{ $t('components.sampleSwatchesDialog.info', { number: 5 - samples.length }) }}
      </div>
      <div class="samplesDialog__actions">
        <v-btn
          class="primary  samplesDialog__action"
          @click="closeDialog"
        >
          <v-icon class="white--text pr-5">
            mdi  mdi mdi-chevron-left
          </v-icon>
          {{ $t('components.sampleSwatchesDialog.back') }}
        </v-btn>
        <v-btn
          class="primary red-bg samplesDialog__action"
          @click="addToCart"
        >
          <v-icon class="white--text pr-5">
            mdi mdi-cart
          </v-icon>
          {{ $t('components.sampleSwatchesDialog.addToCart') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "SampleSwatchesDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    samples: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteSample(index) {
      this.$emit('updateSamples', index)
    },
    addToCart() {
      this.$emit('addToCart')
    }
  }
}
</script>

<style lang="scss">
.samplesDialog {
  &.v-dialog {
    height: 100vh;
    max-height: unset;
    border-radius: 0;
    background: #fff;
    margin: 0 0 0 auto;
    max-width: 100%;
    width: 480px;
    padding: 30px 30px 10px 30px;
  }
  &__title {
    text-transform: uppercase;
    color: #000;
    font-weight: 500;
    font-size: 24px;
    margin-right: 10px;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee8e8;
  }
  &__close {
    cursor: pointer;
  }
  &__info {
    margin-top: auto;
    color: #282828;
    font-size: 15px;
    text-align: center;
    margin-bottom: 30px;
  }
  &__inner {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
  }
  &__price {
    margin-bottom: 10px;
  }
  &__action {
    max-width: 100% !important;
    margin-bottom: 20px;
  }
  &__back {
    margin-bottom: 20px;
  }
}
.samplesList {
  margin-bottom: 20px;
  &__item {
    display: flex;
    padding: 20px 0;
    border-bottom: 1px solid #eee8e8;
  }
  &__img {
    border-radius: 5px;
    margin-right: 30px;
  }
  &__text {
    display: flex;
    flex-direction: column;
    margin-right: 5px;
  }
  &__name {
    color: #015AAB;
    font-weight: 500;
    font-size: 16px;
  }
  &__desc {
    font-size: 14px;
    color: #646464;
  }
  &__delete {
    text-align: center;
    margin-left: auto;
    color: rgba(0, 0, 0, 0.54);
    cursor: pointer;
  }
}
.samplesPrice {
  text-align: right;
  margin-bottom: auto;
  &__value {
    color: #282828;
    font-weight: 700;
    font-size: 28px;
  }
  &__text {
    color: #646464;
    font-size: 14px;
  }
}
.v-application button.red-bg.v-btn.v-btn--has-bg {
  background-color: #E71519 !important;
  border-color: #E71519 !important;
}
</style>
